import { TabContext, TabPanel } from "@mui/lab";
import { Box, Modal, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import AddQuickNote from "./AddQuickNote";
import AddTherapyNote from "./AddTherapyNote";
import AddNonTherapyNote from "./AddNonTherapyNote";
import AddFamilyNote from "./AddFamilyNote";
import AddGroupNote from "./AddGroupNote";
import AddMedicalNote from "./AddMedicalNote";
import AddAftercareNote from "./AddAftercareNote";
import TopTitleNoteContainerMobile from "./TopTitleNoteContainerMobile";
import QuickNotesContainerMobile from "../containers/QuickNotesContainerMobile";
import NonTherapyNoteContainerMobile from "../containers/NonTherapyNoteContainerMobile";
import MedicalNotesMobile from "../containers/MedicalNotesMobile";
import FamilyNotesContainerMobile from "../containers/FamilyNotesContainerMobile";

function NotesTabTherapistForMedicalStaffMobile(props) {
  const styleLive2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };


  const styleFamilyNote2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleGroupNote = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: 750,
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const dateToday = new Date();
  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [openQuickNote, setOpenQuickNote] = useState(false);
  const [openTherapyNote, setOpenTherapyNote] = useState(false);
  const [openNonTherapyNote, setOpenNonTherapyNote] = useState(false);
  const [openFamilyNote, setOpenFamilyNote] = useState(false);
  const [openGroupNote, setOpenGroupNote] = useState(false);
  const [openMedicalNote, setOpenMedicalNote] = useState(false);
  const [openAftercareNote, setOpenAftercareNote] = useState(false);

  const handleOpenQuickNote = () => setOpenQuickNote(true);
  const handleOpenNonTherapyNote = () => setOpenNonTherapyNote(true);
  const handleOpenFamilyNote = () => setOpenFamilyNote(true);
  const handleOpenMedicalNote = () => setOpenMedicalNote(true);

  const handleCloseTherapyNote = () => setOpenTherapyNote(false);
  const handleCloseNonTherapyNote = () => setOpenNonTherapyNote(false);
  const handleCloseQuickNote = () => setOpenQuickNote(false);
  const handleCloseFamilyNote = () => setOpenFamilyNote(false);
  const handleCloseGroupNote = () => setOpenGroupNote(false);
  const handleCloseMedicalNote = () => setOpenMedicalNote(false);
  const handleCloseAftercareNote = () => setOpenAftercareNote(false);

  return (
    // <div className="tab-container-white-mobile">
    <div className="tab-form-container-for-notes-mobile">
      <Modal
        open={openQuickNote}
        onClose={handleCloseQuickNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive2}>
          <AddQuickNote
            closemodal={handleCloseQuickNote}
            clientId={props.clientId}
            {...props}
          />
        </Box>
      </Modal>
      <Modal
        open={openTherapyNote}
        onClose={handleCloseTherapyNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive2}>
          <AddTherapyNote
            dateTherapyNote={dateToday}
            closemodal={handleCloseTherapyNote}
            clientId={props.clientId}
            {...props}
          />
        </Box>
      </Modal>
      <Modal
        open={openNonTherapyNote}
        onClose={handleCloseNonTherapyNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive2}>
          <AddNonTherapyNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseNonTherapyNote}
            clientId={props.clientId}
            {...props}
          />
        </Box>
      </Modal>

      <Modal
        open={openFamilyNote}
        onClose={handleCloseFamilyNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleFamilyNote2}>
          <AddFamilyNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseFamilyNote}
            clientId={props.clientId}
            {...props}
          />
        </Box>
      </Modal>
      <Modal
        open={openGroupNote}
        onClose={handleCloseGroupNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleGroupNote}>
          <AddGroupNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseGroupNote}
            clientId={props.clientId}
            {...props}
          />
        </Box>
      </Modal>
      <Modal
        open={openMedicalNote}
        onClose={handleCloseMedicalNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive2}>
          <AddMedicalNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseMedicalNote}
            clientId={props.clientId}
            {...props}
          />
        </Box>
      </Modal>

      <Modal
        open={openAftercareNote}
        onClose={handleCloseAftercareNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive2}>
          <AddAftercareNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseAftercareNote}
            clientId={props.clientId}
            {...props}
          />
        </Box>
      </Modal>

      <Modal
        open={openNonTherapyNote}
        onClose={handleCloseNonTherapyNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive2}>
          <AddNonTherapyNote
            dateNonTherapyNote={dateToday}
            closemodal={handleCloseNonTherapyNote}
            clientId={props.clientId}
            {...props}
          />
        </Box>
      </Modal>

      <Box
        sx={{
          width: "100%",
        }}
      >
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divier",
              width: "100%",
            }}
          >
            <Tabs
              // sx={{ width: "100%" }}
              variant="scrollable"
              allowScrollButtonsMobile
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab label="Quick notes" value="0" sx={{ fontSize: "10px" }} />
              <Tab
                label="1 to 1 support staff notes"
                value="1"
                sx={{ fontSize: "10px" }}
              />
              <Tab label="Medical notes" value="2" sx={{ fontSize: "10px" }} />
              <Tab
                label="Family / significant other notes"
                value="3"
                sx={{ fontSize: "10px" }}
              />
            </Tabs>
          </Box>
          {/* </Box> */}
          {(() => {
            switch (value) {
              case "0":
                return (
                  <TabPanel value="0">
                    <TopTitleNoteContainerMobile
                      title="Add quick note"
                      handleOpen={handleOpenQuickNote}
                    />
                    <QuickNotesContainerMobile
                      clientId={props.clientId}
                      {...props}
                    />
                  </TabPanel>
                );

              case "1":
                return (
                  <TabPanel value="1">
                    <TopTitleNoteContainerMobile
                      title="Add 1 to 1 support staff notes"
                      handleOpen={handleOpenNonTherapyNote}
                    />
                    <NonTherapyNoteContainerMobile
                      clientId={props.clientId}
                      {...props}
                    />
                  </TabPanel>
                );
              case "2":
                return (
                  <TabPanel value="2">
                    <TopTitleNoteContainerMobile
                      title="Add medical note"
                      handleOpen={handleOpenMedicalNote}
                    />
                    <MedicalNotesMobile clientId={props.clientId} {...props} />
                  </TabPanel>
                );
              case "3":
                return (
                  <TabPanel value="3">
                    <TopTitleNoteContainerMobile
                      title="Add family/significant other note"
                      handleOpen={handleOpenFamilyNote}
                    />
                    <FamilyNotesContainerMobile
                      clientId={props.clientId}
                      {...props}
                    />
                  </TabPanel>
                );

              default:
                return null;
            }
          })()}
        </TabContext>
      </Box>
    </div>
    // </div>
  );
}

export default NotesTabTherapistForMedicalStaffMobile;
